import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export const PublicLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
  </div>
);
